"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.translationsNamespace = exports.defaultTranslations = void 0;
/* istanbul ignore file */

/**
 * DO NOT EDIT!
 * This file was autogenerated by npm script `localizations-codegen`.
 * Changes may cause incorrect behavior and will be lost when the file is regenerated.
 *
 * Run `npx localizations-codegen` to regenerate.
 */

const defaultTranslations = exports.defaultTranslations = {
  favorites: 'Favorites',
  mrp: 'MRP',
  mrpStatement: 'Inclusive of all taxes',
  quickBuy: 'Quick buy',
  regularPrice: 'Regular price',
  subscriptionLabel: 'Subscribe & save'
};
const translationsNamespace = exports.translationsNamespace = 'product-box';
//# sourceMappingURL=defaultTranslations.js.map